import { Badge } from "@mantine/core";
import { semanticColor } from "@how/design-system";

export interface CountBadgeProps {
  /** How many are waiting; nothing is drawn at 0. */
  readonly count: number;
}

/**
 * How many are waiting somewhere (the inbox's unread conversations), beside a navigation row's or a tab's label. Capped
 * at 99+, and hidden from screen readers: the control it sits in names the count in words ("Inbox, 3 unread"), with
 * the visible words first. In the `info` role, so the surface audit measures it on the theme gallery.
 */
export function CountBadge({ count }: CountBadgeProps) {
  if (count <= 0) return null;
  return (
    <Badge size="sm" variant="filled" color={semanticColor("info")} circle={count < 10} aria-hidden>
      {count > 99 ? "99+" : String(count)}
    </Badge>
  );
}
